function isQid(qatarId: string) {
  return /^\d{11}$/.test(qatarId);
}

export function getBirthDateTimestampFromQatarId(qatarId: string): number | null {
  if (!isQid(qatarId)) return null;

  const [centuryFlag, y1, y2] = qatarId;
  const yy = Number(`${y1}${y2}`);

  let year: number | null = null;
  if (centuryFlag === '2') year = 1900 + yy;
  else if (centuryFlag === '3') year = 2000 + yy;
  if (year == null) return null;

  return Date.UTC(year, 0, 1);
}

export function getBirthDateFromQatarId(qatarId: string): string | null {
  if (!isQid(qatarId)) return null;

  const [centuryFlag, y1, y2] = qatarId;
  const yy = Number(`${y1}${y2}`);

  let year: number | null = null;
  if (centuryFlag === '2') year = 1900 + yy;
  else if (centuryFlag === '3') year = 2000 + yy;

  if (year == null) return null;

  return `${year}-01-01`;
}

export function splitFullName(fullName: string): { name: string; lastName: string } {
  // const normalized = fullName.trim().replace(/\s+/g, ' ');
  const normalized = sanitizeName(fullName);

  if (!normalized) return { name: '', lastName: '' };

  const [name, ...rest] = normalized.split(' ');

  return {
    name,
    lastName: rest.join(' '),
  };
}

export function sanitizeName(name: string) {
  return name.trim().replace(/^[-\s]+|[-\s]+$/g, '');
}
